/**
 * Checks if the input value is null or undefined.
 */
export const isNil = (value: unknown): value is null | undefined => value == null

/**
 * Checks if a value is NOT null or undefined.
 */
export const isNotNil = <T>(value: T | null | undefined): value is T => value != null

/**
 * Returns true if the given value is its type's empty value; false otherwise.
 */
export const isEmpty = (x: unknown): boolean => {
  if (x == null) return false
  if (Array.isArray(x)) return x.length === 0
  if (typeof x === 'string') return x.length === 0
  if (x instanceof Map || x instanceof Set) return x.size === 0
  if (x instanceof Date) return false
  if (ArrayBuffer.isView(x)) return (x as unknown as { length: number }).length === 0
  if (typeof x === 'object') return Object.keys(x).length === 0
  return false
}

/**
 * Checks if a value is NOT empty.
 */
export const isNotEmpty = (value: unknown): boolean => !isEmpty(value)
